import { render } from "./SignUpPage.vue?vue&type=template&id=22ad91fa"
import script from "./SignUpPage.vue?vue&type=script&lang=js"
export * from "./SignUpPage.vue?vue&type=script&lang=js"

import "./SignUpPage.vue?vue&type=style&index=0&id=22ad91fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__